import { Component, OnInit } from '@angular/core';
import { TRACK_APP, base_https_url, ISTATACARD, TRACKERROR_CONTACT_LINK, BRAND_APPROVED_PANDEDUPE_ERRORS } from 'src/app/config/app-settings.config';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'app-trackapp-error',
  templateUrl: './trackapp-error.component.html',
  styleUrls: ['./trackapp-error.component.scss']
})
export class TrackappErrorComponent implements OnInit {
  track_app: any;
  IS_TATA = ISTATACARD;
  abortMessage: any;
  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');
  pandedupeCheck: boolean;
  pandedupeMessage: any;
  url: string;
  channelBanca: any;
  trackerror_contact_link: any;
  base_url: any;
  
  shotCodeServiceFailedErr: boolean = false;
  shotCodeExpiredErr: boolean = false;
  
  constructor(
    private sharedService:SharedServiceService,
    private themeService: ThemeService
    ) { 
      this.partnerCode = this.themeService.partnerCode;
   }

  ngOnInit() {
    this.base_url = base_https_url;
    this.abortMessage = this.sharedService.abortMessage;
    this.trackerror_contact_link = TRACKERROR_CONTACT_LINK;
    if (this.sharedService.trackApplicationResponse) {
      this.channelBanca = this.sharedService.trackApplicationResponse.channelCode;
    } else {
      this.channelBanca = this.sharedService.qdeSubmitData && this.sharedService.qdeSubmitData.WSCallChannelCode ? this.sharedService.qdeSubmitData.WSCallChannelCode : null;
    }
    if(this.channelBanca ==='EALB' || this.IS_TATA == true ||  this.sharedService.paramschannel =='901' || sessionStorage.getItem('channelId')=='901') {
    this.pandedupeCheck = false;
    } else {
      this.pandedupeCheck = this.sharedService.panDedupeErrorMulticard;
    }
    //this.pandedupeCheck = true;
    //this.sharedService.pandedupeAbortMessage = BRAND_APPROVED_PANDEDUPE_ERRORS;
    this.pandedupeMessage = this.sharedService.pandedupeAbortMessage;
  }
  widgetAction() {
    const domainUrl = window.location.hostname;
    this.url = 'https://'+ domainUrl +'/creditcards/app/service/multicarding-page';
    window.open(this.url,"_blank");
  }
  homeRedirect(){
    // window.location.href="https://www.sbicard.com/en/home.page";
    window.history.go(-2);
  }
}
